import React from "react";
import Hero from "../../components/home/hero/Hero";
import LastPitch from "../../components/home/lastPitch/LastPitch";
import Partners from "../../components/home/partners/Partners";
import Testimony from "../../components/home/testimony/Testimony";
import Charity from "../../components/home/charity/Charity";
import Stats from "../../components/home/stats/Stats";
import Work from "../../components/home/works/Work";
import { homeAPI } from "../../lib/homeAPIConnect";
import { useEffect, useState } from "react";
import { loadGtag } from "../../utility/loadGtag";

function Home() {
  const [totalStats, setTotalStats] = useState(null);
  const [categoryData, setCategoryData] = useState([]);

  async function fetchStats() {
    try {
      const stats = await homeAPI.getStatsAPI();
      setTotalStats(stats);
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  }

  const fetchData = async () => {
    try {
      const data = await homeAPI.getCauseCategoryAPI();
      setCategoryData(data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchStats();
    loadGtag();
  }, []);

  return (
    <>
      <Hero totalStats={totalStats} />
      <Work />
      <Stats totalStats={totalStats} />
      <Charity categoryData={categoryData} />
      <Testimony />
      <Partners />
      <LastPitch />
    </>
  );
}

export default Home;
